<script lang="ts">
    import Select from "svelte-select"
    import {
        filterConfig,
        numberOperators,
        operatorMap,
        operatorTooltipMapWithExamples,
        stringArrayOperators,
    } from "./config"
    import { tooltip } from "../../../../helper"
    import { _ } from "svelte-i18n"

    export let filter: PriceCalculationExceptionFilter
    const operatorType = filterConfig[filter.attribute]?.operatorType
    const operatorValues = operatorType === "stringArray" ? stringArrayOperators : numberOperators
    let operatorValue = {
        label: filter.operator ? filter.operator : "",
        value: filter.operator,
    }
    $: filter.operator = operatorValue.value
</script>

<Select
    placeholder="{$_('components.pcalc.comparisonOperator')}"
    bind:value="{operatorValue}"
    items="{operatorValues.map((e) => ({ label: e, value: operatorMap[e] }))}"
    clearable="{false}"
    showChevron="{true}"
>
    <div class="selection" slot="selection" let:selection>
        <div class="selection-label">{$_("components.pcalc.comparisonOperator")}</div>
        <div class="selection-value">
            {selection.label}
        </div>
    </div>
    <div
        slot="item"
        let:item
        use:tooltip="{{
            content: operatorTooltipMapWithExamples[item.label],
        }}"
    >
        {item.label}
    </div>
</Select>
